// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/page/jobPosting/JobPosting.css
// module id = 495
// module chunks = 0